import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaStar, FaRegStar } from "react-icons/fa";
import {
  agregarPelicula,
  eliminarPelicula,
} from "../redux/slices/FavouriteSlice";
import { SeeMoreButton } from "./SeeMoreButton";
import SeriesModal from "./SeriesModal";

const SeriesCard = ({ series, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const favoritos = useSelector((state) => state.favoritos.peliculas);

  // Verificar si la serie está en favoritos
  const isFavorite = favoritos.some(
    (fav) => fav.id === series.id && fav.type === "series"
  );

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    if (isFavorite) {
      dispatch(eliminarPelicula({ ...series, type: "series" }));
    } else {
      dispatch(agregarPelicula({ ...series, type: "series" }));
    }
  };

  const handleMoreInfoClick = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };

  // Función para manejar el click en la tarjeta (ahora muestra el modal en lugar de navegar)
  const handleCardClick = () => {
    setShowModal(true);
  };

  return (
    <>
      <div
        className="relative m-4 transition-all duration-300 ease-in-out hover:scale-110 hover:z-10 cursor-pointer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleCardClick}
      >
        <div className="relative p-1 border border-white border-opacity-50 rounded-lg shadow-lg bg-black-800">
          <img
            src={
              series.poster ||
              "https://via.placeholder.com/300x450?text=Sin+imagen"
            }
            alt={series.name}
            className="object-cover w-full h-[200px] md:h-[250px] lg:h-[300px] rounded-lg"
          />
          {isHovered && (
            <div className="absolute inset-0 flex flex-col justify-end p-4 bg-black bg-opacity-75 rounded-lg">
              <h3 className="mb-2 text-xs font-bold text-white xl:text-lg 2xl:text-xl lg:text-base md:text-sm">
                {series.name}
              </h3>
              {series.releaseYear && (
                <span className="text-white">{series.releaseYear}</span>
              )}
              {(series.genres ?? series.genre) &&
                (() => {
                  const raw = series.genres ?? series.genre; // <- acepta ambos
                  const list = Array.isArray(raw)
                    ? raw.map((g) => String(g).trim()).filter(Boolean)
                    : String(raw)
                        .split(",")
                        .map((g) => g.trim())
                        .filter(Boolean);
                  const text = list.join(", ");
                  return <span className="text-white">{text}</span>;
                })()}

              {/* {series.genres && (
                <span className="text-white">
                  {typeof series.genres === 'string' ? series.genres : series.genres.join(', ')}
                </span>
              )} */}
              {series.totalSeasons && (
                <span className="text-white">
                  {series.totalSeasons}{" "}
                  {series.totalSeasons === 1 ? "temporada" : "temporadas"}
                </span>
              )}
              <div className="flex flex-col items-center justify-between lg:flex-row">
                <button
                  onClick={handleFavoriteClick}
                  className="p-2 rounded-full"
                >
                  {isFavorite ? (
                    <FaStar className="text-2xl text-yellow-500" />
                  ) : (
                    <FaRegStar className="text-2xl text-white" />
                  )}
                </button>

                <SeeMoreButton handleMoreInfoClick={handleMoreInfoClick} />
              </div>
            </div>
          )}
        </div>
      </div>
      {showModal && (
        <SeriesModal series={series} onClose={() => setShowModal(false)} />
      )}
    </>
  );
};

export default SeriesCard;
